import { type FC, type ReactNode } from 'react';
import FooterContent from '@components/page/FooterContent.tsx';
import { twMerge } from '@beerntea/pitcher-ui';
import { Header } from '@components/page/Header.tsx';
import { FooterDisclaimer } from '@components/page/FooterDisclaimer.tsx';
import {
  AppleIcon,
  BeatportIcon,
  FacebookIcon,
  InstagramIcon,
  SoundCloudIcon,
  SpotifyIcon,
  TikTokIcon,
  TwitterIcon,
  YoutubeIcon,
} from '@components/Icons';

type Props = {
  children: ReactNode;
  className?: string;
};
export const OuterBounds = ({ children, className }: Props) => {
  return (
    <div className={twMerge('tw-bg-black', 'tw-min-h-screen tw-relative', 'tw-overflow-hidden', className)}>
      <div className="tw-fixed tw-top-0 tw-right-0 tw-bottom-0 tw-left-0 tw-overflow-hidden tw-z-40 tw-pointer-events-none">
        <div className="noise-overlay tw-absolute tw-inset-0  tw-bg-noise tw-opacity-60 " />
      </div>
      {children}
    </div>
  );
};

type ViewProps = {
  children: ReactNode;
  className?: string;
  affix?: boolean;
};

const Master: FC<ViewProps> = ({ children, className = '', affix = false }) => {
  const menu = {
    navItems: [
      {
        label: 'HOME',
        to: '/#top',
        bg: '/uploads/assets/0/static/img/menu/bg-home.jpg',
      },
      {
        label: 'MY STORY',
        to: '/#my-story',
        bg: '/uploads/assets/0/static/img/menu/bg-my-story.jpg',
      },
      {
        label: 'TOURDATES',
        to: '/#tourdates',
        bg: '/uploads/assets/0/static/img/menu/bg-tourdates.jpg',
      },
      {
        label: 'RELEASES',
        to: '/#releases',
        bg: '/uploads/assets/0/static/img/menu/bg-releases.jpg',
      },
      {
        label: 'SHOP',
        to: '/shop',
        bg: '/uploads/assets/0/static/img/menu/bg-shop.jpg',
      },
      {
        label: 'ON AIR',
        to: '/#hardwell-on-air',
        bg: '/uploads/assets/0/static/img/menu/bg-hoa.jpg',
      },
      {
        label: 'CONTACT',
        to: '/contact',
        bg: '/uploads/assets/0/static/img/menu/bg-contact.jpg',
      },
    ],
    subMenu: [
      { url: 'https://revealedrecordings.com', label: 'REVEALED' },
      { url: 'https://anna-agency.com', label: 'ANNA AGENCY' },
      { url: 'https://sortedmanagement.com', label: 'SORTED MANAGEMENT' },
    ],
    socials: [
      // Facebook,
      { icon: <FacebookIcon />, url: 'https://www.facebook.com/djhardwell' },
      // X,
      { icon: <TwitterIcon />, url: 'https://x.com/hardwell' },
      // Instagram,
      { icon: <InstagramIcon />, url: 'http://instagram.com/hardwell/' },
      // YouTube,
      { icon: <YoutubeIcon />, url: 'http://www.youtube.com/hardwelltube' },
      // TikTok -
      { icon: <TikTokIcon />, url: 'https://www.tiktok.com/@hardwell' },
      // Spotify,
      { icon: <SpotifyIcon />, url: 'http://open.spotify.com/user/hardwellofficial' },
      // Soundcloud,
      { icon: <SoundCloudIcon />, url: 'http://www.soundcloud.com/hardwell' },
      // AppleMusic,
      { icon: <AppleIcon />, url: 'https://itunes.apple.com/nl/artist/hardwell/id270486655' },
      // Beatport
      {
        icon: <BeatportIcon />,
        url: 'https://www.beatport.com/artist/hardwell/66652?srsltid=AfmBOopC4G45gEtBCCsPL7IC_weJL1PgM1b2G583nT4IPehX-vx84Eah',
      },
    ],
  };

  return (
    <OuterBounds className={className}>
      <Header
        menu={menu}
        affix={affix}
      />

      <div className="">{children}</div>

      <footer className="tw-bg-black tw-text-white tw-w-screen">
        <div className="tw-mx-auto tw-max-w-[1680px] tw-bg-black tw-text-white">
          <FooterContent />
        </div>
        <FooterDisclaimer />
      </footer>
    </OuterBounds>
  );
};

export default Master;
